import './amount-container-item.scss'
import React from 'react'

interface AmountContainerItemInterface {
  title: string,
  amount_value: string,
}

const AmountContainerItem = ({ ...props }: AmountContainerItemInterface) => {
  return (
    <div className='polymer-amount-container-item'>
      <div className='polymer-amount-container-item__top'>
        <p>{props.title}</p>
      </div>
      <div className='polymer-amount-container-item__bottom'>
        <p>{props.amount_value}</p>
      </div>
    </div>
  )
}

export default AmountContainerItem